import { Button, CircularProgress, Link, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Form, Field } from 'react-final-form'
import logo from 'images/logo.png'


import useAuth, { useNotAuthenticatedOnly } from 'useAuth'


import "./style.css"
import firebaseUtil from 'firebaseUtil'

const renderTextField = ({ input, label, meta: { touched, error }, valid, loginUsuario, handleSubmit, ...custom }) => (
    <TextField
        variant="standard"
        InputLabelProps={{
            shrink: true,
        }}
        style={{ marginBottom: 15 }}
        label={label}
        error={(touched && error) ? true : false}
        helperText={(touched && error) ? error : ""}
        onKeyDown={(e) => {
            if (e.keyCode === 13 && valid) {
                handleSubmit(loginUsuario);
            }
        }}
        fullWidth

        {...input}
        {...custom}
    />
)



export default function LoginPage() {
    const [errorMenssage, setErrorMenssage] = useState(null);
    const navigate = useNavigate();
    const { redirectPosAuth, registerLogin } = useAuth();

    useNotAuthenticatedOnly();



    const loginUsuario = async (dados) => {
        return new Promise((resolve, reject) => {

            firebaseUtil.login(dados.email, dados.senha)
                .then((user) => {
                    registerLogin()
                    redirectPosAuth()
                    navigate("/")
                    resolve()
                }).catch((error) => {

                    let errorMensage = "";
                    switch (error.code) {
                        case 'auth/invalid-email':
                            errorMensage = 'Endereço de e-mail Inválido'
                            break;
                        case 'auth/user-disabled':
                            errorMensage = 'O usuário pode ter sido desativado';
                            break;
                        case 'auth/user-not-found':
                            errorMensage = 'Não há registro de usuário correspondente a esse identificador. O usuário pode ter sido excluído';
                            break;
                        case 'auth/wrong-password':
                            errorMensage = 'Senha inválida ou o usuário não tem uma senha';
                            break;
                        default:
                            break;
                    }
                    setErrorMenssage(errorMensage)
                    reject()
                })
        })
    }

    return (

        <div className='loginContainer' >
            <div className='loginPaper' >
                <Form
                    onSubmit={loginUsuario}
                    render={({ handleSubmit, form, submitting, pristine, values, valid }) => (
                        <form onSubmit={handleSubmit}>
                            <div style={{ display: 'flex', justifyContent: "center", padding: 10, marginBottom: 10, backgroundColor: "#fff" }}>
                                <img className='logoLogin' src={logo} alt="Logo" />
                            </div>
                            {errorMenssage && <Typography style={{ color: "#f00" }}> {errorMenssage}</Typography>}
                            <div style={{ padding: 10 }}>

                                <Field name="email" label="Email" valid={valid} handleSubmit={handleSubmit} loginUsuario={loginUsuario} component={renderTextField} />
                                <Field name="senha" label="Senha" valid={valid} handleSubmit={handleSubmit} loginUsuario={loginUsuario} type="password" component={renderTextField} />
                                <div style={{ display: 'flex', justifyContent: "center" }}>

                                    <Button variant="contained" color="primary" style={{ margin: 8 }}
                                        onClick={handleSubmit}
                                        disabled={submitting}>
                                        {!submitting && 'Login'}
                                        {submitting && <CircularProgress />}
                                    </Button>
                                    {/* <Button variant="contained" color="primary" style={{ margin: 8 }}
                                // onClick={() => { this.props.history.push(rotaSignUp) }}
                                >Criar Conta</Button> */}
                                </div>
                            </div>
                        </form>)}
                />
                <Link style={{ width: '100%' }}
                    component="button"
                    variant="body2"
                    color="secondary"
                    onClick={() => {
                        //  this.props.history.push(rotaSendEmail)
                    }}
                >
                    <Typography
                        color="primary"
                        style={{ fontSize: 12 }}
                        onClick={() => {
                            navigate("/forgot-password")
                        }}
                    >
                        Esqueci minha senha
                    </Typography>
                </Link>
            </div>
        </div>


    )
}

// const validate = values => {
//     const errors = {}

//     if (!values.email) {
//         errors.email = 'Requerido'
//     } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
//         errors.email = 'Email inválido'
//     }
//     if (!values.password) {
//         errors.password = 'Requerido'
//     }
//     return errors
// }
